import { ReactComponent as Icon } from "./ProfileIcon-thin.svg";

export const ProfileIcon = (): JSX.Element => {
  return (
    <Icon className="ProfileIcon" />
  );
};
